import { ArrowDownRight, ArrowUpRight } from 'lucide-react';
import { DashboardRecentActivityAPI } from '@/api/type';
import { useTranslation } from 'react-i18next';

interface RecentCommissionsListProps {
  commissions: DashboardRecentActivityAPI['data']['recent_commissions'];
}

export const RecentCommissionsList = ({ commissions }: RecentCommissionsListProps) => {
  const { t } = useTranslation();

  return (
    <div className="!bg-white dark:!bg-dark-card rounded-xl shadow-sm border border-gray-200 dark:border-dark-border">
      <div className="p-4 sm:p-5 border-b border-gray-200 dark:border-dark-border">
        <h2 className="text-lg sm:text-xl font-bold !text-gray-900 dark:!text-white !mb-0">
          {t('dashboard.recent_commissions')}
        </h2>
      </div>

      <div className="p-4 sm:p-5">
        <div className="space-y-2">
          {commissions.length === 0 && (
            <p className="text-center !text-gray-500 dark:!text-dark-text-secondary italic !mb-0">
              {t('dashboard.no_commissions')}
            </p>
          )}
          {commissions.map((commission, index) => (
            <div
              key={index}
              className="flex items-center justify-between p-3 rounded-md !bg-gray-50 dark:!bg-dark-card-elevated hover:!bg-gray-100 dark:hover:!bg-dark-border transition-colors border border-gray-100 dark:border-dark-border"
            >
              <div className="flex items-center space-x-3">
                <div
                  className={`w-9 h-9 sm:w-10 sm:h-10 rounded-full flex items-center justify-center flex-shrink-0 ${
                    commission.description.includes('Trực tiếp')
                      ? '!bg-green-100 dark:!bg-green-900/20'
                      : '!bg-blue-100 dark:!bg-blue-900/20'
                  }`}
                >
                  {commission.description.includes('Trực tiếp') ? (
                    <ArrowDownRight className="w-4 h-4 sm:w-5 sm:h-5 !text-green-600 dark:!text-green-400" />
                  ) : (
                    <ArrowUpRight className="w-4 h-4 sm:w-5 sm:h-5 !text-blue-600 dark:!text-blue-400" />
                  )}
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-semibold !text-gray-900 dark:!text-white !mb-0 truncate">
                    {commission?.user_info?.fullname}
                  </p>
                  <p className="text-xs !text-gray-500 dark:!text-dark-text-secondary !mb-0">
                    {commission.date}
                  </p>
                </div>
              </div>
              <div className="text-right flex-shrink-2 !ml-2">
                <p className="text-sm sm:text-base font-bold !text-success !mb-0">
                  +{Number(commission.amount).toLocaleString('vi-VN',{ maximumFractionDigits: 0 })}đ
                </p>
                <p className="text-xs !text-gray-500 dark:!text-dark-text-secondary !mb-0 capitalize">
                  {commission.description || t('dashboard.commission')}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
